import { useEffect, useState } from "react";
import SimpleButton from '../common/SimpleButton/SimpleButton'
import closeImg from "../../assets/images/btn_close.webp"
import imgClaimBtn from "../../assets/images/btn_yellow.webp"
import imgClaimBtnComplete from "../../assets/images/btn_gray.webp"
import imgBGTicket from "../../assets/images/daily_bg_ticket.webp"
import imgTicket from "../../assets/images/ticket_black.webp"
import imgClock from "../../assets/images/daily_sandclock.webp"
import { Trans } from "@lingui/react/macro";
import s from './ModalDaily.module.css'
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";

interface ModalDailyProps {
    closeModal: () => void;
}

const ModalDaily: React.FC<ModalDailyProps> = ({ closeModal }) => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.game.user);

    const [timeLeft, setTimeLeft] = useState({
        hours: "00",
        minutes: "00",
        seconds: "00",
    });

    const claimTicket = () => {
        if (user.seconds_to_claim != 0) return;

        dispatch({ type: 'game/claimTicket' });
        closeModal();
    }

    useEffect(() => {
        if (user.seconds_to_claim == 0) return;
        const targetTime = new Date().getTime() + user.seconds_to_claim * 1000;

        const updateTimer = () => {
            const now = new Date().getTime();
            const difference = targetTime - now;

            if (difference <= 0) {
                setTimeLeft({
                    hours: "00",
                    minutes: "00",
                    seconds: "00",
                });
                clearInterval(timerInterval);
            } else {
                const hours = String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, "0");
                const minutes = String(Math.floor((difference / (1000 * 60)) % 60)).padStart(2, "0");
                const seconds = String(Math.floor((difference / 1000) % 60)).padStart(2, "0");

                setTimeLeft({ hours, minutes, seconds });
            }
        };

        updateTimer();
        const timerInterval = setInterval(updateTimer, 1000);

        return () => clearInterval(timerInterval);
    }, []);

    return (
        <div className={s.containerWrapper}>
            <SimpleButton imageUrl={closeImg} width={12} onClick={closeModal} className={s.closePosition} />

            <div className={s.container}>
                <img className={s.imgBGTicket} src={imgBGTicket} alt="ticket" />
                <p className={s.text}><Trans>Collect tickets and rise to the top!</Trans></p>

                <SimpleButton
                    className={s.button}
                    onClick={claimTicket}
                    imageUrl={user.seconds_to_claim > 0 ? imgClaimBtnComplete : imgClaimBtn}
                    disabled={user.seconds_to_claim > 0}
                >
                    <img className={s.imgTicket} src={imgTicket} alt="ticket" />
                    <p className={s.buttonText}><Trans>Claim 1 ticket</Trans></p>
                </SimpleButton>

                <div className={s.timerBox}>
                    <img className={s.imgClock} src={imgClock} alt="sandclock" />
                    <p className={s.timerText}>
                        <span>{timeLeft.hours}</span> :
                        <span>{timeLeft.minutes}</span> :
                        <span>{timeLeft.seconds}</span>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ModalDaily